import MinusIcon from '../../assets/logo/MinusIcon';
import PlusIcon from '../../assets/logo/PlusIcon';
import classNames from 'classnames';
import useTheme from '../../hooks/ui/useTheme';
import { ButtonTypes } from '../../services/exports/Interfaces';

type ModifierToggleButtonProps = {
  quantity: number;
  isSelected: boolean;
  increase(): void;
  decrease(): void;
  isIncreasable: boolean;
  isUpsell?: boolean;
};

const ModifierToggleButton = (props: ModifierToggleButtonProps) => {
  const { quantity, isSelected, increase, decrease, isIncreasable, isUpsell } = props;
  const theme = useTheme();
  const hasDecreaseButton = isSelected;
  const hasIncreaseButton = isIncreasable;
  const increaseButtonClassName = classNames(iconContainer, {
    '!bg-brand-button-primary-background': isUpsell,
  });

  return (
    <>
      {hasDecreaseButton && (
        <button
          className={iconContainer}
          onClick={(e) => {
            e.stopPropagation();
            decrease();
          }}
          disabled={!isSelected}
        >
          <MinusIcon className="size-2" color={theme.color.brand.icon.color} />
        </button>
      )}
      {!!quantity && <div>{quantity}</div>}
      {hasIncreaseButton && (
        <button
          className={increaseButtonClassName}
          onClick={(e) => {
            e.stopPropagation();
            increase();
          }}
        >
          <PlusIcon
            className="size-2"
            color={isUpsell ? theme.buttons[ButtonTypes.primary].text : theme.color.brand.text.primary}
          />
        </button>
      )}
    </>
  );
};

// TODO: add to custom colors
const iconContainer = 'w-6 h-6 bg-gray-800 dark:bg-black-600 rounded-full flex items-center justify-center';

export default ModifierToggleButton;
